var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRamadanGiftIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M48.338 17.806H15.661c-6.054 0-10.983 4.93-10.983 10.984v1.674h4.685v18.772c0 6.755 5.477 12.231 12.231 12.231h20.781c6.755 0 12.231-5.477 12.231-12.231V30.464h4.686V28.79c0-6.055-4.93-10.984-10.984-10.984h.03z",
    fill: "url(#d7xj1ap0na)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.862 61.467h-6.268c-6.754 0-12.23-5.507-12.23-12.261V30.433H4.677V28.79A10.96 10.96 0 0 1 15.66 17.806h6.268A10.96 10.96 0 0 0 10.945 28.79v1.643h4.686v18.773c0 6.754 5.477 12.261 12.231 12.261z",
    fill: "url(#nzd9msmv8b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.138 61.467h6.267c6.755 0 12.231-5.507 12.231-12.261V30.433h4.686V28.79a10.96 10.96 0 0 0-10.984-10.984h-6.267A10.96 10.96 0 0 1 53.054 28.79v1.643H48.37v18.773c0 6.754-5.477 12.261-12.231 12.261z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 61.467v-43.66m0 0c-3.469 0-6.268-7.211-6.268-10.071 0-2.86 2.8-5.203 6.268-5.203s6.268 2.312 6.268 5.203c0 2.89-2.8 10.07-6.268 10.07zM16.118 8.617c0 5.081 7.089 9.188 15.852 9.188 8.762 0 15.851-4.107 15.851-9.188M9.363 30.464h45.243v18.772c0 6.755-5.477 12.231-12.231 12.231h-20.78c-6.755 0-12.232-5.476-12.232-12.23V30.462zm6.298-12.657h32.677c6.055 0 10.984 4.928 10.984 10.983v1.674H4.678V28.79c0-6.055 4.929-10.983 10.983-10.983z",
    stroke: "url(#i0qpdiltzc)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d7xj1ap0na",
    x1: 6.85,
    y1: 48.752,
    x2: 47.63,
    y2: 23.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nzd9msmv8b",
    x1: 5.6,
    y1: 48.752,
    x2: 27.999,
    y2: 42.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i0qpdiltzc",
    x1: 6.852,
    y1: 44.304,
    x2: 53.474,
    y2: 22.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRamadanGiftIcon);
export default __webpack_public_path__ + "static/media/ramadanGiftIcon.5252032e169fa582852d22f348fb0ccf.svg";
export { ForwardRef as ReactComponent };